import type { VideoViewerDialogProperties } from "../video.model";

export function useVideoViewer() {
  const dialog = useDialog("VideoViewerDialog");

  function open(properties: VideoViewerDialogProperties) {
    return dialog.open(properties);
  }

  return { open };
}
